module.exports = __webpack_public_path__ + "static/media/goblin_shaman.23396a34.svg";